import { render, staticRenderFns } from "./CreateCorruptionGroup.vue?vue&type=template&id=4f54b739&"
import script from "./CreateCorruptionGroup.vue?vue&type=script&lang=js&"
export * from "./CreateCorruptionGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateCorruptionGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports